import { combineReducers } from 'redux';

const prizes = [
  {
    id: 1,
    points: 25,
    isOffer: false,
  },
  {
    id: 2,
    points: 50,
    isOffer: false,
  },
  {
    id: 3,
    points: 100,
    isOffer: false,
  },
];

const rewards = (state = prizes) => state;

export default combineReducers({
  rewards,
});
